import { calculatedBmi } from '../../../helper/bmi';
import { TGoal } from '../../molecules/HealthGoalSelection';

const HEALTH_GOAL_AGREEMENT = {
	pregnant: 'pregnant',
	underweight: 'underweight',
	overweight: 'overweight',
} as const;

type THealthGoalAgreement = keyof typeof HEALTH_GOAL_AGREEMENT;

interface IOptions {
	isPregnant?: boolean;
	bmiValue: number;
	selectedGoal?: TGoal;
	weightInput?: number;
	weight?: number;
	size?: number;
}

export function getHealthGoalRequiredAgreement({
	isPregnant,
	selectedGoal,
	weightInput,
	weight,
	size,
	bmiValue,
}: IOptions): THealthGoalAgreement | undefined {
	if (selectedGoal === 'healthier') {
		return;
	}

	if (isPregnant) {
		return HEALTH_GOAL_AGREEMENT.pregnant;
	}

	function calculateBmi() {
		if (selectedGoal === 'fruits' && weightInput) {
			return calculatedBmi(weight, size, weightInput, true, true);
		}

		return bmiValue;
	}

	const isLoseWeight = selectedGoal === 'fruits';
	const isCalculatedToLow = calculateBmi() <= 18.5;
	const isInitialOverweight = bmiValue >= 30;

	if (!isLoseWeight && isCalculatedToLow && !isInitialOverweight) {
		return HEALTH_GOAL_AGREEMENT.underweight;
	}

	if (isInitialOverweight && !isCalculatedToLow) {
		return HEALTH_GOAL_AGREEMENT.overweight;
	}

	return;
}
